import { NavItemType } from "components/Navigation/NavigationItem";
import fingerTipsIcon from "images/new/icons/fingertips.svg";
import _ from "lodash";
import { Route } from "routers/types";

const randomId = _.uniqueId;

export const MEGAMENU_TEMPLATES: NavItemType[] = [
  {
    id: randomId(),
    href: "/payment",
    name: "Payment",
  },
  {
    id: randomId(),
    href: "/online-banking",
    name: "Online Banking",
  },
  {
    id: randomId(),
    href: "/foreign-exchange",
    name: "Foreign Exchange",
  },
];

const OTHER_PAGE_CHILD: NavItemType[] = [
  // author pages ----------------
  {
    id: randomId(),
    href: "/about",
    name: "About",
  },
  {
    id: randomId(),
    href: "/careers",
    name: "Careers",
  },
  {
    id: randomId(),
    href: "/contact",
    name: "Contact us",
  },
];

export const services: NavItemType[] = [
  {
    id: "online-banking",
    name: "Online Banking",
    href: "/services/online-banking",
    description: "Manage your accounts, make payments, and track transactions in real-time",
    type: "megaMenu",
    icon: fingerTipsIcon,
  },
  {
    id: "payments",
    name: "Payments",
    href: "/services/payments",
    description: "Process payments securely and efficiently across multiple currencies",
    type: "megaMenu",
    icon: fingerTipsIcon,
  },
  {
    id: "foreign-exchange",
    name: "Foreign Exchange",
    href: "/services/foreign-exchange",
    description: "Get competitive rates for international transfers and currency exchange",
    type: "megaMenu",
    icon: fingerTipsIcon,
  },
];

export const MAIN_NAVIGATION: NavItemType[] = [
  {
    id: randomId(),
    href: "/" as Route,
    name: "Home",
  },

  //
  {
    id: randomId(),
    href: "/payment" as Route,
    name: "Services",
    type: "megaMenu",
    children: MEGAMENU_TEMPLATES,
  },
  {
    id: randomId(),
    href: "/about" as Route,
    name: "Company",
  },
  {
    id: randomId(),
    href: "/careers" as Route,
    name: "Careers",
  },
  {
    id: randomId(),
    href: "/contact" as Route,
    name: "Contact us",
  },

  // {
  //   id: randomId(),
  //   href: "/",
  //   name: "Company",
  //   type: "dropdown",
  //   children: OTHER_PAGE_CHILD,
  // },
];
